module.exports = __webpack_public_path__ + "static/media/settings.88eb86cc.svg";